import { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';
import { getAdminIndustryEnquiries } from '../../services/api';

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getAdminIndustryEnquiries().then(res => { setItems(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <>
      <div className="admin-table-wrap">
        <div className="admin-table-header">
          <h2>Industry Enquiries ({items.length})</h2>
        </div>
        {items.length === 0 ? (
          <div className="empty-state"><h3>No enquiries submitted yet</h3><p>Industry-specific enquiries will appear here</p></div>
        ) : (
          <table className="admin-table">
            <thead><tr><th>Name</th><th>Company</th><th>Industry</th><th>Email</th><th>Phone</th><th>Date</th><th>Actions</th></tr></thead>
            <tbody>
              {items.map(item => (
                <tr key={item.id}>
                  <td style={{ fontWeight: 600 }}>{item.name}</td>
                  <td>{item.companyName || '-'}</td>
                  <td><span className="status-badge status-published">{item.industry}</span></td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => setSelected(item)}><Eye size={14} /> View</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Enquiry Details</h2>
            <div style={{ display: 'grid', gap: 16 }}>
              <div><strong>Name:</strong> {selected.name}</div>
              {selected.companyName && <div><strong>Company:</strong> {selected.companyName}</div>}
              <div><strong>Email:</strong> {selected.email}</div>
              <div><strong>Phone:</strong> {selected.phone}</div>
              <div><strong>Industry:</strong> {selected.industry}</div>
              <div><strong>Date:</strong> {new Date(selected.createdAt).toLocaleString()}</div>
              <div>
                <strong>Requirement:</strong>
                <p style={{ marginTop: 8, color: '#475569', lineHeight: 1.7, background: '#f8fafc', padding: 16, borderRadius: 8 }}>
                  {selected.requirement}
                </p>
              </div>
            </div>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setSelected(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
